import { Box, SvgIcon, SvgIconProps } from "@mui/material";
import * as React from "react";

export interface IconProps extends SvgIconProps {}

const CloseExpendIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props}><path d="M1.68 24 0 22.32l7.92-7.92H2.4V12H12v9.6H9.6v-5.52L1.68 24ZM12 12V2.4h2.4v5.52L22.32 0 24 1.68 16.08 9.6h5.52V12H12Z"/></SvgIcon>
  );
};

export default CloseExpendIcon;